import { emptyArray } from 'Lib/constants/placeholder';
import {
  EntitySchema,
  LocallyNormalizedSchema,
  ProcessedResultSchema,
  ResponseSchema,
} from 'Lib/schemas';

export const categorySchema = new EntitySchema(
  'category',
  {},
  {
    idAttribute: 'code',
    processStrategy(value, parent) {
      const categoryConsents = (parent.consents || emptyArray).filter(
        ({ categoryCode }) => categoryCode === value.code
      );
      return {
        ...value,
        consents: categoryConsents.map(({ code }) => code),
        // Category-level state is cosmetic and calculated from the individual consents within
        enabled: categoryConsents.reduce(
          (anyEnabled, { enabled, defaultValue }) =>
            anyEnabled || enabled || (enabled !== false && defaultValue),
          false
        ),
      };
    },
    unprocessStrategy(value) {
      const category = { ...value };
      delete category.consents;
      return category;
    },
  }
);

export const consentSchema = new EntitySchema('consent', {}, { idAttribute: 'code' });

const consentsSchema = new ProcessedResultSchema(
  new LocallyNormalizedSchema({
    categories: [categorySchema],
    consents: [consentSchema],
  }),
  {
    processResult({ entities, result }) {
      const categoryData = entities.category;
      const consentData = entities.consent;

      // Effective values for consents where user input has already been given or is not required
      const consents = {};

      // Category preferences used for future consents in the category
      // These aren't used directly by the client.
      result.categories.forEach((category) => {
        if (!categoryData[category].requiresInput) {
          consents[`:${category}`] = categoryData[category].defaultValue;
        }
      });

      // Consent preferences that determine whether or not a tracker is enabled
      result.consents.forEach((consent) => {
        if (!consentData[consent].requiresInput) {
          consents[consent] =
            consentData[consent].enabled == null
              ? consentData[consent].defaultValue
              : consentData[consent].enabled;
        }
      });

      return {
        categoryData,
        categoryOrder: result.categories,
        consentData,
        consents,
      };
    },
  }
);

export const consentsResponseSchema = new ResponseSchema(consentsSchema);

export const consentsErrorResponseSchema = new ResponseSchema({});
